/* @flow */

import React, { Component } from "react";

import ModalWithTrigger from "platopulse/components/ModalWithTrigger";
import Tooltip from "platopulse/components/Tooltip";
import Icon from "platopulse/components/Icon";
import { t } from 'c-3po';
import PlatopulseAnalytics from "platopulse/lib/analytics";

import EmbedModalContent from "./EmbedModalContent";

import cx from "classnames";

import type { EmbeddableResource, EmbeddingParams } from "platopulse/public/lib/types";
import type { Parameter } from "platopulse/meta/types/Parameter";

type Props = {
    className?: string,

    resource: EmbeddableResource,
    resourceType: string,
    resourceParameters:  Parameter[],

    siteUrl: string,
    secretKey: string,
    isAdmin: boolean,

    getPublicUrl: (resource: EmbeddableResource, extension: ?string) => string,

    onUpdateEnableEmbedding: (enable_embedding: bool) => Promise<void>,
    onUpdateEmbeddingParams: (embedding_params: EmbeddingParams) => Promise<void>,
    onCreatePublicLink: () => Promise<void>,
    onDisablePublicLink: () => Promise<void>,
};

export default class EmbedWidget extends Component {
    props: Props;

    _modal: ?ModalWithTrigger

    render() {
        const { className, resourceType } = this.props;
        return (
            <ModalWithTrigger
                ref={m => this._modal = m}
                full
                triggerElement={
                    <Tooltip tooltip={t`Sharing and embedding`}>
                        <Icon name="share" onClick={() => PlatopulseAnalytics.trackEvent("Sharing / Embedding", resourceType, "Sharing Link Clicked") } />
                    </Tooltip>
                }
                triggerClasses={cx(className, "text-brand-hover")}
                className="scroll-y"
            >
                <EmbedModalContent
                    {...this.props}
                    onClose={() => { this._modal && this._modal.close() }}
                    className="full-height"
                />
            </ModalWithTrigger>
        );
    }
}



// WEBPACK FOOTER //
// ./public/components/widgets/EmbedWidget.jsx